document.addEventListener('DOMContentLoaded', function () {
  // Search icon functionality
  const searchIcon = document.querySelector('.custom-search-icon');
  const headerSearch = document.querySelector('.header__search');
  if (searchIcon && headerSearch) {
    searchIcon.addEventListener('click', function (e) {
      e.stopPropagation();
      headerSearch.style.display = 'block';
    });
  
    headerSearch.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  
    document.addEventListener('click', function () {
      headerSearch.style.display = 'none';
    });
  }
  
  // Country selector toggle - simple open/close only
  document.addEventListener('click', function (e) {
    const toggleBtn = e.target.closest('.country-selector__toggle');
    
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();
      
      const container = toggleBtn.closest('.country-selector');
      const isOpen = container.classList.contains('open');
      
      // Close all dropdowns
      document.querySelectorAll('.country-selector').forEach(function (selector) {
        selector.classList.remove('open');
        const tb = selector.querySelector('.country-selector__toggle');
        if (tb) tb.setAttribute('aria-expanded', 'false');
      });
      
      // Toggle this dropdown
      if (!isOpen) {
        container.classList.add('open');
        toggleBtn.setAttribute('aria-expanded', 'true');
      }
    }
  });

  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.country-selector')) {
      document.querySelectorAll('.country-selector').forEach(function (selector) {
        selector.classList.remove('open');
        const tb = selector.querySelector('.country-selector__toggle');
        if (tb) tb.setAttribute('aria-expanded', 'false');
      });
    }
  });
});
